
import { Injectable } from '@angular/core';
// import { DropDownConfig } from '../interfaces/dropdown.config';
import { KeyCloakOptions } from '../interfaces/keycloak-options.config';

import { KeyCloakUrls } from '../interfaces/keycloak-urls.config';
import { environment } from '../shared/environments/environment.prod';
// import { environment } from '../modules/shared/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

//* Represents the environment variables for the project that can be
//* injected anywhere in our application using Angular dependency injection

//? If env.js cannot be loaded, the application will fall back to
//? the default values defined in this class.
export class EnvService {

  // The values that are defined here are the default values
  // that can be overridden by env.js

  //local
  // public keyCloakUrls: KeyCloakUrls = {
  //   baseUrl: environment.urlMapping.DOMAIN_URL + '/auth',
  //   redirectUrl: 'http://localhost:5200/landing-page',
  //   logoutUrl: 'http://localhost:5200/username'
  // }

  //server
  public keyCloakUrls: KeyCloakUrls = {
    baseUrl: environment.urlMapping.DOMAIN_URL + '/auth',
    redirectUrl: environment.urlMapping.DOMAIN_URL + '/landing-page',
    logoutUrl: environment.urlMapping.DOMAIN_URL + '/username'
  }

  public keyCloakOptions: KeyCloakOptions = {
    //server
    clientId: 'ccusermgmt',
    realm: 'ConnectedCustomerUM',
    keyCloakUrls: {
      baseUrl: this.keyCloakUrls.baseUrl,
      redirectUrl: this.keyCloakUrls.redirectUrl,
      logoutUrl: this.keyCloakUrls.logoutUrl
    }
  }
  
  //local
  // public baseUrl : string = 'http://localhost:8081/api/';

  // public applicationBaseUrl: string = 'http://localhost:5200/sales/'

  //server

  public baseUrl : string = environment.urlMapping.DOMAIN_URL + '/um/';

  public applicationBaseUrl: string = 'https://connectedenterprise.vassardigital.ai/'

  public appRedirectUrl : string = 'home';

  public userMgmtRedirectUrl : string = 'home';

  public headerAppName : string = 'Connected Enterprise';

  public isCustomerDropdownRequired : boolean = true;

  // public customerDropDownValues : DropDownConfig[] = [];

  public insuranceUrl:string='https://dev.smartclaim.vassardigital.ai';
}
